// extracted by mini-css-extract-plugin
module.exports = {"MainColor":"#259572","SecondaryColor":"#37b874","Main-bg":"#f2f4f7"};